import { HELP_EMAIL } from '@/shared/config/HELP_EMAIL'

import { FooterKey } from '../../../types/FooterKey'

interface FooterLinksKeys {
	title: FooterKey
	links: Array<{
		name: FooterKey

		url?: string

		// TODO: Change this in future
		href?: string

		/**
		 * @default false
		 */
		isImplemented?: boolean
	}>
}

export const footerLinkKeys: FooterLinksKeys[] = [
	{
		title: 'company',
		links: [
			{ name: 'aboutUS', url: '/' },
			{ name: 'features', url: '/' },
			{ name: 'partnership', url: '/' },
			{ name: 'career', url: '/' }
		]
	},
	{
		title: 'contacts',
		links: [
			{ name: 'facebook', url: '/' },
			{ name: 'instagram', url: '/' },
			{ name: 'youtube', url: '/' },
			{ name: 'liveChat', url: '/' }
		]
	},
	{
		title: 'help',
		links: [
			{
				name: 'customerSupport',
				href: `mailto:${HELP_EMAIL}`,
				isImplemented: true
			},
			{ name: 'termsConditions', url: '/' },
			{ name: 'privacyPolicys', url: '/' },
			{ name: 'cookiesPolicy', url: '/' }
		]
	},
	{
		title: 'frequentlyAskedQuestions',
		links: [
			{ name: 'howDoIChangeBookingDates', url: '/' },
			{ name: 'whenwillIreceiveRefund', url: '/' },
			{ name: 'whatAreCurrentCOVIDRestrictions', url: '/' },
			{ name: 'bookingCancellationOptions', url: '/' }
		]
	}
]
